import Devices from '@/services/api/device';

export default {
  namespaced: true,
  state: {
    devices: [],
    device: {},
  },
  getters: {
    devices: state => state.devices,
    device: state => state.device,
  },
  mutations: {
    setDevices: (state, payload) => {
      state.devices = payload;
    },
    setDevice: (state, payload) => {
      state.device = payload;
    },
  },
  actions: {
    getDevices (state, options = {}) {
      return new Promise((resolve, reject) => {
        Devices.getDevices(options)
          .then(({ data }) => {
            state.commit('setDevices', data.devices);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDevice (state, id) {
      return new Promise((resolve, reject) => {
        Devices.getDevice(id)
          .then(({ data }) => {
            state.commit('setDevice', data.device);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDevice (state, payload) {
      return new Promise((resolve, reject) => {
        Devices.updateDevice(payload)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDeviceBarrier (state, payload) {
      return new Promise((resolve, reject) => {
        Devices.updateDeviceBarrier(payload)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDeviceController (state, payload) {
      return new Promise((resolve, reject) => {
        Devices.updateDeviceController(payload)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteDevice (state, id) {
      return new Promise((resolve, reject) => {
        Devices.deleteDevice(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    newDevice (state, params) {
      return new Promise((resolve, reject) => {
        Devices.newDevice(params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    newDeviceBarrier (state, params) {
      return new Promise((resolve, reject) => {
        Devices.newDeviceBarrier(params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    newDeviceController (state, params) {
      return new Promise((resolve, reject) => {
        Devices.newDeviceController(params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    exportCsv (state) {
      return new Promise((resolve, reject) => {
        Devices.exportCsv()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateFirmwareVersions (state) {
      return new Promise((resolve, reject) => {
        Devices.updateFirmwareVersions()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getDeviceInfo (state, { ipAddress, type }) {
      return new Promise((resolve, reject) => {
        Devices.getDeviceInfo(ipAddress, type)
          .then(({ data }) => {
            state.commit('setDevice', data.device);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDeviceFreeSip (state) {
      return new Promise((resolve, reject) => {
        Devices.getDeviceFreeSip()
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDeviceFreeCityPhone (state) {
      return new Promise((resolve, reject) => {
        Devices.getDeviceFreeCityPhone()
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    newDeviceGsm (state, params) {
      return new Promise((resolve, reject) => {
        Devices.newDeviceGsm(params)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDeviceGsm (state, payload) {
      return new Promise((resolve, reject) => {
        Devices.updateDeviceGsm(payload)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteDeviceGsm (state, id) {
      return new Promise((resolve, reject) => {
        Devices.deleteDeviceGsm(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
